import React from 'react';
import PropTypes from 'prop-types';

import {
    Button, Flex, Heading, Image, Label, ModalDialog, Paragraph,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import BuildablePlan from 'app/shared/images/BuildablePlan.svg';

const propTypes = {
    close: PropTypes.func.isRequired,
};
const defaultProps = {};

const ToolExplanationModal = ({ close, ...rest }) => (
    <ModalDialog
        {...rest}
        wide={true}
        header={
            <Heading level={6}>Enabling Rent Guarantee</Heading>
        }
        body={(
            <>
                <Flex display="flex" alignItems="center" flexDirection="column" marginBottom="xs">
                    <Image src={BuildablePlan} alt="" />
                    <Heading level={6}>How Zillow tools make it work</Heading>
                </Flex>
                <Row>
                    <Col xs={2} />
                    <Col xs={8}>
                        <Label>Applications</Label>
                        <Paragraph fontType="bodySmall">
                        •  Credit check ensures the renter meets minimium requirements for credit score and
                        income-to-rent ratio.
                        </Paragraph>
                        <Paragraph fontType="bodySmall" marginBottom="lg">
                        •  Background report verifies the renter doesn’t have any disqualifying events, such as
                        previous evictions.
                        </Paragraph>
                        <Label>Payments</Label>
                        <Paragraph fontType="bodySmall" marginBottom="lg">
                        •  Record of payment transactions between the landlord and renter clearly indicates if
                        rent payments are missed.
                        </Paragraph>
                        <Label>Leases</Label>
                        <Paragraph fontType="bodySmall">
                        •  Terms in the lease agreement signed online by the renter(s) and landlord can help
                        verify the claim and process it quickly.
                        </Paragraph>
                    </Col>
                    <Col xs={2} />
                </Row>
            </>
        )}
        footer={
            <Button buttonType="primary" onClick={close}>Okay</Button>
        }
    />
);

ToolExplanationModal.propTypes = propTypes;
ToolExplanationModal.defaultProps = defaultProps;

export default ToolExplanationModal;
